import { apiRequest } from '../../../common/services/httpService';
import type { ProfileInfo } from '../domain/profile';

export const getUserProfile = async () => {
	const authToken = localStorage.getItem('authToken');
	return apiRequest('/api/v1/user/profile', 'GET', authToken);
};

export const updateUserProfile = async ({ input }: { input: ProfileInfo }) => {
	const authToken = localStorage.getItem('authToken');
	return apiRequest('/api/v1/user', 'PUT', authToken, input);
};
